<fal [i]="icon"
     class="detail-icon"
     [ngbTooltip]="!displayLabel && label">
</fal>
<div class="detail-content">
    <div class="actions-cnt" *ngIf="actions?.length">
        <ng-container *ngFor="let action of actions">
            <app-action-icon *ngIf="!action?.condition || action.condition()"
                             [icon]="action.icon"
                             [tooltip]="action.label"
                             [active]="action?.getActive?.()"
                             [class.visible]="action.getVisible?.()"
                             (click)="action.action()"
                             size="sm"
                             variant="regular">
            </app-action-icon>
        </ng-container>
    </div>
    <div *ngIf="displayLabel"
         [@toggleOpen]="displayLabel"
         class="d-flex align-items-center">
        <div>
            <small class="detail-label">
                {{ label }}
            </small>
        </div>
        <fas *ngIf="hasError"
             i="exclamation-circle"
             class="text-danger ml-2"
             [ngbTooltip]="errorMessage">
        </fas>
        <fas *ngIf="hasWarning"
             i="exclamation-circle"
             class="text-warning ml-2"
             [ngbTooltip]="warningMessage">
        </fas>
        <div class="label-extra ml-auto" *ngIf="labelExtraTmp">
            <ng-container *ngTemplateOutlet="labelExtraTmp"></ng-container>
        </div>
    </div>
    <div *ngIf="!isEditing else editViewTmp" class="d-flex">
        <div>
            <ng-container *ngIf="!contentTmp; else contentTmp">
                <span *ngIf="content; else noDataShort" style="white-space: pre-line">{{ content }}</span>
            </ng-container>
        </div>
        <div *ngIf="isUpdated" class="text-primary ml-3">
            <span *ngIf="updatesContent; else emptyIndication" style="white-space: pre-line">{{ updatesContent }}</span>
            <ng-template #emptyIndication><fal i="minus"></fal></ng-template>
        </div>
    </div>
    <ng-content></ng-content>
</div>

<ng-template #noDataShort>
    <fal i="minus" class="text-muted"></fal>
</ng-template>
